import PostHog from 'posthog-react-native';
import constants, { isPatientApp } from '@/config/constants';
import { Platform } from 'react-native';

export const posthog = new PostHog(constants.posthogApiKey || '', {
  host: constants.posthogHost || 'https://eu.i.posthog.com',
  disableGeoip: true,
  defaultOptIn: constants.posthogEnabled,
  captureAppLifecycleEvents: true,
  enableSessionReplay: false,
  customAppProperties: (defaults) => ({
    ...defaults,
    app_version: constants.appVersion,
    platform: Platform.OS,
    platform_version: Platform.Version,
    app_id: isPatientApp
      ? 'neolexon-aphasia-patient'
      : 'neolexon-aphasia-therapist',
  }),
});

// Narrow helpers so consumers only depend on the analytics calls they need,
// rather than the full client (which only the provider should hold).
export const identifyUser = (distinctId: string) =>
  posthog.identify(distinctId);

export const resetPostHog = () => posthog.reset();
